import { render, staticRenderFns } from "./TableDefault.vue?vue&type=template&id=15909022&"
import script from "./TableDefault.vue?vue&type=script&lang=js&"
export * from "./TableDefault.vue?vue&type=script&lang=js&"
import style0 from "./TableDefault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports